'use client'

import { useState, useEffect } from 'react'

/**
 * SSR-safe `matchMedia` hook (mismo patrón que `useOrientation`): inicializa en
 * `false` en el servidor y sincroniza tras montar, así no hay mismatch de
 * hidratación (el póster de la card se renderiza siempre, sin salto de layout).
 */
function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mediaQuery = window.matchMedia(query)
    const handleChange = () => setMatches(mediaQuery.matches)

    handleChange()
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [query])

  return matches
}

/** True bajo el breakpoint 768px (el mismo que usan los hero-mocks). */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)')
}

/** True cuando el usuario pide reducir movimiento (desactiva el autoplay en hover). */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)')
}
